import React from 'react';
import { useAppDispatch } from 'store/hooks';
import { useParams } from 'react-router-dom';
import { useFormikContext } from 'formik';

import { updateLessonById } from 'store/lesson/actions';

import AnswersTypeSelect from './AnswersTypeSelect';

const AnswersTypeSelectContainer = () => {
  const dispatch = useAppDispatch();
  const { values } = useFormikContext<any>();

  const { lessonId } = useParams();

  const handleOptionClick = (option: any) => {
    try {
      dispatch(
        updateLessonById({
          lessonId,
          lessonType: values.type,
          data: { answersType: option.value },
          changedPropertiesKeys: ['answersType'],
        }),
      );
    } catch (error) {
      console.warn(error);
    }
  };

  return <AnswersTypeSelect onOptionClick={handleOptionClick} />;
};

export default React.memo(AnswersTypeSelectContainer) as any;
